import { sliderProps, Slider } from './chunk-JQ3KENEW.js';
import { sliderValueFormatContext } from './chunk-U43VNZZW.js';
import { SliderStoreFactory } from './chunk-53B74NMI.js';
import { functionThrottle } from './chunk-JELAJF2G.js';
import { formatSpokenTime, formatTime } from './chunk-JY53PGKC.js';
import { ClassManager } from './chunk-KDDYW2ND.js';
import { onTrackChapterChange } from './chunk-NOPW2CG3.js';
import { setAttributeIfEmpty } from './chunk-Z6A4GYXE.js';
import { $$_computed, $$_peek, $$_clone, $$_effect, $$_attr, $$_insert_lite, $$_style, $$_create_template } from 'maverick.js/dom';
import { signal, provideContext, effect, peek } from 'maverick.js';
import { defineElement, defineProp } from 'maverick.js/element';
import { listenEvent } from 'maverick.js/std';

var $$_templ = /* @__PURE__ */ $$_create_template(`<div part="chapters"></div>`);
var $$_templ_2 = /* @__PURE__ */ $$_create_template(`<div part="chapter-container"><div part="chapter"><div part="track"></div><div part="track track-fill"></div><div part="track track-progress"></div></div></div>`);
var SliderChaptersRenderer = class {
  constructor(_media, _slider, _onChange) {
    this.a = _media;
    this.H = _slider;
    this.o = _onChange;
    this.na = [];
  }
  render(cues, $class) {
    return cues?.length ? $$_peek(
      () => (() => {
        const $$_root = $$_clone($$_templ);
        $$_effect(() => $$_attr($$_root, "class", $class()));
        $$_insert_lite($$_root, () => this.Hg(cues));
        return $$_root;
      })()
    ) : null;
  }
  Hg(cues) {
    this.na = this.Ig(cues);
    const firstChapter = this.na[0];
    this.o(firstChapter && firstChapter.startTime === 0 ? firstChapter.text : "");
    return this.na.map((cue, i) => {
      const $width = this.Jg.bind(this, cue), $fill = this.Kg.bind(this, cue), $buffered = this.Lg.bind(this, cue);
      return (() => {
        const $$_root = $$_clone($$_templ_2);
        $$_effect(() => $$_style($$_root, "--width", $width()));
        $$_effect(() => $$_style($$_root, "--slider-fill-percent", $fill()));
        $$_effect(() => $$_style($$_root, "--media-buffered-percent", $buffered()));
        return $$_root;
      })();
    });
  }
  Jg(cue) {
    const lastChapter = this.na[this.na.length - 1];
    return (cue.endTime - cue.startTime) / lastChapter.endTime * 100 + "%";
  }
  Kg(cue) {
    let percent = this.Ec(cue, this.H.fillPercent()), currentPercent = percent;
    if (this.H.pointing()) {
      currentPercent = this.Ec(cue, this.H.pointerPercent());
    }
    if (currentPercent > 0 && currentPercent < 100) {
      this.o(cue.text);
    }
    return percent + "%";
  }
  Lg(cue) {
    const percent = this.a.bufferedEnd() / this.a.duration() * 100;
    return this.Ec(cue, percent) + "%";
  }
  Ha(percent) {
    return Math.round(percent / 100 * this.a.duration());
  }
  Ig(cues) {
    const chapters = [];
    for (let i = 0; i < cues.length - 1; i++) {
      const currentCue = cues[i], nextCue = cues[i + 1];
      chapters.push(currentCue);
      if (nextCue) {
        const timeDiff = nextCue.startTime - currentCue.endTime;
        if (timeDiff > 0) {
          chapters.push(new window.VTTCue(currentCue.endTime, currentCue.endTime + timeDiff, ""));
        }
      }
    }
    chapters.push(cues[cues.length - 1]);
    return chapters;
  }
  Ec(cue, percent) {
    const lastChapter = this.na[this.na.length - 1], startPercent = cue.startTime / lastChapter.endTime * 100, endPercent = cue.endTime / lastChapter.endTime * 100;
    return Math.max(
      0,
      percent >= endPercent ? 100 : (percent - startPercent) / (endPercent - startPercent) * 100
    );
  }
};

// src/player/ui/sliders/time-slider/time-slider.tsx
var TimeSlider = class extends Slider {
  constructor(instance) {
    super(instance);
    this.pc = true;
    this.m = signal(null);
    this.Hc = false;
    // -------------------------------------------------------------------------------------------
    // Chapters
    // -------------------------------------------------------------------------------------------
    this.$a = null;
    this.Td = signal("");
    provideContext(sliderValueFormatContext, {
      value: this.Mg.bind(this),
      time: this.Ng.bind(this)
    });
  }
  onAttach(el) {
    setAttributeIfEmpty(el, "aria-label", "Media time");
    super.onAttach(el);
    this.Rd = new SliderChaptersRenderer(
      this.a.$store,
      this.$store,
      this.Td.set
    );
    this.setAttributes({
      "data-chapters": this.Og.bind(this)
    });
    effect(this.Ya.bind(this));
    effect(this.Pg.bind(this));
    effect(this.Gc.bind(this));
  }
  Og() {
    const { duration } = this.a.$store;
    this.Sd?.J();
    return this.m()?.cues.length && Number.isFinite(duration()) && duration() > 0;
  }
  onConnect(el) {
    super.onConnect(el);
    this.ka();
    listenEvent(this.a.textTracks, "mode-change", this.ka.bind(this));
    const { chapterContainerClass, chapterClass, trackClass, trackFillClass, trackProgressClass } = this.$props;
    this.Sd = new ClassManager(el).t('[part="chapter-container"]', chapterContainerClass).t('[part="chapter"]', chapterClass).t('[part="track"]', trackClass).t('[part~="track-fill"]', trackFillClass).t('[part~="track-progress"]', trackProgressClass);
  }
  render() {
    const tracks = super.render(), { chaptersClass } = this.$props;
    return [$$_computed(() => this.Rd.render(this.m()?.cues, chaptersClass)), tracks];
  }
  Pg() {
    this.Fc = functionThrottle(
      this.aa.bind(this),
      this.$props.seekingRequestThrottle()
    );
  }
  Ya() {
    const { currentTime } = this.a.$store, { value, dragging } = this.$store, newValue = this.Qg(currentTime());
    if (!peek(dragging)) {
      value.set(newValue);
      this.dispatch("value-change", { detail: newValue });
    }
  }
  aa(time, event) {
    this.a.remote.seeking(time, event);
  }
  Rg(time, percent, event) {
    this.Fc.cancel();
    const { live } = this.a.$store;
    if (live() && percent >= 99) {
      this.a.remote.seekToLiveEdge(event);
      return;
    }
    this.a.remote.seek(time, event);
  }
  Id(event) {
    const { pauseWhileDragging } = this.$props;
    if (pauseWhileDragging()) {
      const { paused } = this.a.$store;
      this.Hc = !paused();
      this.a.remote.pause(event);
    }
  }
  mc(event) {
    this.Fc(this.Ha(event.detail), event);
  }
  nc(event) {
    const percent = event.detail;
    this.Rg(this.Ha(percent), percent, event);
    const { pauseWhileDragging } = this.$props;
    if (pauseWhileDragging() && this.Hc) {
      this.a.remote.play(event);
      this.Hc = false;
    }
  }
  lc(event) {
    const { dragging } = this.$store;
    if (dragging() || !event.trigger)
      return;
    this.nc(event);
  }
  // -------------------------------------------------------------------------------------------
  // Props
  // -------------------------------------------------------------------------------------------
  tb() {
    return this.$props.step() / this.a.$store.duration() * 100;
  }
  Ld() {
    return this.$props.keyStep() / this.a.$store.duration() * 100;
  }
  q() {
    const { canSeek } = this.a.$store;
    return super.q() || !canSeek();
  }
  // -------------------------------------------------------------------------------------------
  // ARIA
  // -------------------------------------------------------------------------------------------
  sc() {
    return 0;
  }
  tc() {
    return 100;
  }
  Md() {
    const time = this.Ha(this.$store.value()), { duration } = this.a.$store;
    return Number.isFinite(time) ? `${formatSpokenTime(time)} out of ${formatSpokenTime(duration())}` : "live";
  }
  // -------------------------------------------------------------------------------------------
  // Format
  // -------------------------------------------------------------------------------------------
  Ha(percent) {
    const { duration } = this.a.$store;
    return Math.round(percent / 100 * duration());
  }
  Qg(time) {
    const { liveEdge, duration } = this.a.$store, rate = Math.max(0, Math.min(1, liveEdge() ? 1 : Math.min(time, duration()) / duration()));
    return Number.isNaN(rate) ? 0 : Number.isFinite(rate) ? rate * 100 : 100;
  }
  Mg(percent) {
    const time = this.Ha(percent), { live, duration } = this.a.$store;
    return Number.isFinite(time) ? (live() ? time - duration() : time).toFixed(0) : "LIVE";
  }
  Ng(percent, padHours, padMinutes, showHours) {
    const time = this.Ha(percent), { live, duration } = this.a.$store, value = live() ? time - duration() : time;
    return Number.isFinite(time) ? `${value < 0 ? "-" : ""}${formatTime(Math.abs(value), padHours, padMinutes, showHours)}` : "LIVE";
  }
  ka() {
    onTrackChapterChange(this.a.textTracks, peek(this.m), this.m.set);
  }
  Gc() {
    this.m();
    this.$a = this.el.querySelector('[part="chapter-title"]');
    if (!this.$a)
      return;
    effect(this.Sg.bind(this));
    return () => {
      this.$a.textContent = "";
      this.$a = null;
    };
  }
  Sg() {
    this.$a.textContent = this.Td();
  }
};
TimeSlider.el = defineElement({
  tagName: "media-time-slider",
  props: {
    ...sliderProps,
    min: defineProp({ value: 0, attribute: false }),
    max: defineProp({ value: 100, attribute: false }),
    value: defineProp({ value: 0, attribute: false }),
    pauseWhileDragging: false,
    seekingRequestThrottle: 100,
    chaptersClass: null,
    chapterContainerClass: null,
    chapterClass: null
  },
  store: SliderStoreFactory
});

export { TimeSlider };
